import { getCommentTypeByActiveTab } from './getCommentTypeByActiveTab';

export const forEachPositionTriggerByGuid = (
    positionGuid: string,
    callback: (triggerElement: Element) => void
): void => {
    const normalizedPositionGuid = String(positionGuid).trim();
    const commentType = getCommentTypeByActiveTab();
    const isExcessTab = commentType === 'excessComment';

    if (!normalizedPositionGuid) {
        return;
    }

    document.querySelectorAll('[data-position-action="openCommentPopup"]').forEach((element) => {
        const positionElement = element.closest('.position');
        const triggerPositionGuid = isExcessTab
            ? element.getAttribute('data-position-id') ||
              positionElement?.getAttribute('data-position-id') ||
              element.getAttribute('data-position-guid') ||
              positionElement?.getAttribute('data-position-guid') ||
              positionElement?.getAttribute('data-excess-guid') ||
              ''
            : element.getAttribute('data-position-guid') ||
              positionElement?.getAttribute('data-position-guid') ||
              positionElement?.getAttribute('data-position-id') ||
              positionElement?.getAttribute('data-excess-guid') ||
              '';

        if (String(triggerPositionGuid).trim() !== normalizedPositionGuid) {
            return;
        }

        callback(element);
    });
};
